import styled from "styled-components";
import {GameJackpotBarLabelDefaultBox} from "./game-jackpot-bar-label.default.box";

export const GameJackpotBarLabelMrgreenBox = styled(GameJackpotBarLabelDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.4rem;
    }
`;